import {toFarsiNumber} from "./toFarsiNumber";

export function toFarsiDate  (n) {
    let array = n.toString().split('/')
   for(let i=0;i<array.length;i++){
       array[i]=toFarsiNumber(array[i])
   }
   return array[0]+'/'+array[1]+'/'+array[2]

}

export function toFarsiDateAdmin (n){
    let moment = require('jalali-moment');
    let array =  moment.from(n, 'en', 'YYYY-MM-DD')
                        .locale('fa')
                        .format('jYYYY-jMM-jDD')
                        .toString()
                        .split('-')

    for (let i=0; i< array.length; i++){
        array[i]=toFarsiNumber(array[i])
    }
    return array[0]+'/'+array[1]+'/'+array[2]
}
